/**
 * Actions for Written Answer Checks (WACs)
 */
export const START_WAC = 'START_WAC';
export const OPEN_WAC_OVERLAY = 'OPEN_WAC_OVERLAY';
export const ANSWER_WAC = 'ANSWER_WAC';
export const WAC_CORRECT = 'WAC_CORRECT';
export const WAC_INCORRECT = 'WAC_INCORRECT';
export const WAC_HAVENT_DONE_THIS = 'WAC_HAVENT_DONE_THIS';
export const CLOSE_WAC_OVERLAY = 'CLOSE_WAC_OVERLAY';
export const CANCEL_WAC = 'CANCEL_WAC';

/**
 * Action to initiate a written answer check (by getting the data for it
 * from the server and showing the WAC view)
 * @param taskItem The task item that the user was starting when the WAC is
 * initiated
 */
export function startWAC(taskItem) {
    return { type: START_WAC, taskItem };
}

/**
 * openWACOverlay happens after startWAC and makes the WAC Overlay appear on
 * the Task View.
 * @param activityIndex the activity index of the WAC activity in the Sparx
 * Cloud session
 */
export function openWACOverlay(activityIndex) {
    return { type: OPEN_WAC_OVERLAY, activityIndex };
}

export function cancelWAC() {
    return { type: CANCEL_WAC };
}

/**
 * Action to answer a written answer check. You need to provide either a
 * text answer (string), a choice answer (which is an integer index
 * denoting one of the choices in the choices list), or true to
 * notWrittenDown (to denote the user did not write the answer down)
 * @param textAnswer a string containing an answer typed by the user or
 * entered via the keypad
 * @param choiceAnswer an integer denoting which choice in the choice list
 * the user has chosen
 * @param optionAnswer an answer from a choice of answer options for the WAC
 * any question type method
 * @param notWrittenDown if true signifies that the user did not write down
 * the answer
 */
export function answerWAC(
    textAnswer,
    choiceAnswer = null,
    optionAnswer = null,
    notWrittenDown = false,
) {
    return { type: ANSWER_WAC, textAnswer, choiceAnswer, notWrittenDown, optionAnswer };
}

/**
 * wacCorrect is fired when the student has passed the bookwork check. If consecutiveWAC is
 * true, we want to customise the text on the continue button so the student knows to expect
 * another WAC.
 */
export function wacCorrect(consecutiveWAC) {
    return { type: WAC_CORRECT, consecutiveWAC };
}

/**
 * wacIncorrect is fired when the student has failed the bookwork check and
 * includes the ID of the task item that has been failed. If consecutiveWAC is
 * true, we want to customise the text on the continue button so the student knows to expect
 * another WAC.
 */
export function wacIncorrect(taskItemId, consecutiveWAC) {
    return { type: WAC_INCORRECT, taskItemId, consecutiveWAC };
}

/**
 * wacHaventDoneThis is fired when the student admits they haven't done their
 * bookwork and includes the ID of the task item that has been failed. If consecutiveWAC is
 * true, we want to customise the text on the continue button so the student knows to expect
 * another WAC.
 */
export function wacHaventDoneThis(taskItemId, consecutiveWAC) {
    return { type: WAC_HAVENT_DONE_THIS, taskItemId, consecutiveWAC };
}

/**
 * closeWACOverlay happens when a WAC is finished and makes the WAC Overlay
 * disappear.
 * @param continueToQuestion defines whether the WAC overlay should continue
 * to the question or not
 */
export function closeWACOverlay(continueToQuestion = false) {
    return { type: CLOSE_WAC_OVERLAY, continueToQuestion };
}
